/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from '@tanstack/react-query'
import Container from '../Container'
import Full from '../Full'
import { ComponentRenderer } from '../renderers/comp/wholeComponents'
import { getEntriesByIds } from '~/lib/contensis/misc'
// import Loader from '~/components/UI/General/Loader/Loader'

const WholeLayout = ({ content, padding }: any) => {
  const componentIds =
    content?.component?.map((c: any) => c?.sys?.id).filter(Boolean) || []

  const { data } = useQuery({
    queryKey: ['layout-whole', componentIds],
    queryFn: async () => {
      return componentIds.length ? getEntriesByIds(componentIds) : []
    },
    enabled: componentIds.length > 0
  })

  // if (isLoading)
  //   return (
  //     <div className='py-l flex w-full justify-center'>
  //       <Loader fill={'#f5b6dc'} />
  //     </div>
  //   )
  // if (error) return <div>Error loading components</div>

  return (
    <>
      <Container columns='full' padding={padding} config={content}>
        <Full>
          {Array.isArray(data) &&
            data.map((item: any, index: number) => (
              <ComponentRenderer
                key={index}
                components={item}
                layoutColour={content.backgroundColour || 'white'}
              />
            ))}
        </Full>
      </Container>
    </>
  )
}

export default WholeLayout
